import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';

/**
 * 通用布局组件
 * 为所有页面提供统一的 Header 和布局结构
 */
export default function Layout({ children }) {
  const [activeFilter, setActiveFilter] = useState('Active');
  const location = useLocation();

  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
  };

  // 只在首页显示筛选标签
  const showFilters = location.pathname === '/';

  return (
    <div className="min-h-screen bg-plypto-bg">
      {/* 固定头部 */}
      <div className="fixed top-0 left-0 right-0 z-50">
        <Header 
          activeFilter={activeFilter}
          onFilterChange={handleFilterChange}
          showFilters={showFilters}
        />
      </div>
      
      {/* 页面内容 - 根据是否显示筛选标签调整顶部边距 */}
      <main className={showFilters ? "pt-32" : "pt-20"}>
        {React.cloneElement(children, { 
          activeFilter, 
          onFilterChange: handleFilterChange 
        })}
      </main>
    </div>
  );
}
